import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { Order } from '../types/order.type'
import type { IEntity } from '../types/entities.type'
import type { IOrderFormJson } from '../types/order-form-json.type'
import type { OrderFormParamsLayout } from '../types/order-form-params-layout.type'
import type { TOrderFormParams } from '../types/order-form-params.type'

export type State = {
  sellers?: IEntity[] | undefined
  orderSelected: Order | undefined
  ordersSelected: string[]
  entityTypeSelected: string
  isOpenModalSelectSeller: boolean
  updatedProductDetails: boolean
  isCalculationOrder?: boolean
	isCalculationComissionOrder?: boolean
  operationType: 'add' | 'edit' | 'view'
  jsonOrderForm: IOrderFormJson | undefined
  paramsOrderForm: TOrderFormParams | undefined
  paramsLayoutOrderForm: OrderFormParamsLayout | undefined
}

export type Action = {
  actions?: {
    setSellers: (sellers: State['sellers']) => void
    setOrderSelected: (props: Order) => void
    setEntityTypeSelected: (props: string) => void
    setIsOpenModalSelectSeller: (props: boolean) => void
    setIsCalculationOrder: (props: boolean) => void
    setIsCalculationComissionOrder: (props: boolean) => void
    setUpdatedProductDetails: (props: boolean) => void
    setOperationType: (operation: 'add' | 'edit' | 'view') => void
    setJsonOrderForm: (payload: IOrderFormJson | undefined) => void
    setParamsOrderForm: (payload: TOrderFormParams | undefined) => void
    setParamsLayoutOrderForm: (
      payload: OrderFormParamsLayout | undefined,
    ) => void
    setOrdersSelected: (orders: string[]) => void
  }
}

export const OrderFormStore = create(
  persist<State & Action>(
    (set) => ({
      sellers: undefined,
      orderSelected: undefined,
      operationType: 'add',
      entityTypeSelected: '',
      jsonOrderForm: undefined,
      isCalculationOrder: false,
			isCalculationComissionOrder: false,
      paramsOrderForm: undefined,
      isOpenModalSelectSeller: false,
      paramsLayoutOrderForm: undefined,
      ordersSelected: [],
      updatedProductDetails: false,
      actions: {
        setSellers: (sellers) => set({ sellers }),
        setOrderSelected: (props) => set({ orderSelected: props }),
        setJsonOrderForm: (payload) =>{
          set({
            jsonOrderForm: payload,
          })},
        setParamsOrderForm: (payload) =>
          set({
            paramsOrderForm: payload,
          }),
        setOperationType: (operation) =>
          set({
            operationType: operation,
          }),
        setIsCalculationOrder: (props) =>
          set({
            isCalculationOrder: props,
          }),
					  setIsCalculationComissionOrder: (props) =>
          set({
            isCalculationComissionOrder: props,
          }),
        setEntityTypeSelected: (props) =>
          set({
            entityTypeSelected: props,
          }),
        setParamsLayoutOrderForm: (payload) =>
          set({
            paramsLayoutOrderForm: payload,
          }),
        setOrdersSelected: (orders) =>
          set({
            ordersSelected: orders,
          }),
        setUpdatedProductDetails: (props) =>
          set({
            updatedProductDetails: props,
          }),
        setIsOpenModalSelectSeller: (props) =>
          set({
            isOpenModalSelectSeller: props,
          }),
      },
    }),
    {
      name: 'order-form',
      partialize: (state) => ({
        ordersSelected: state.ordersSelected,
        orderSelected: state.orderSelected,
        jsonOrderForm: state.jsonOrderForm,
        operationType: state.operationType,
        paramsOrderForm: state.paramsOrderForm,
        entityTypeSelected: state.entityTypeSelected,
        paramsLayoutOrderForm: state.paramsLayoutOrderForm,
        isCalculationOrder: state.isCalculationOrder,
        updatedProductDetails: state.updatedProductDetails,
        isOpenModalSelectSeller: state.isOpenModalSelectSeller,
      }),
    },
  ),
)

export const useOrderFormStore = OrderFormStore
export const useOrderFormStoreActions = () => {
  const { actions } = OrderFormStore.getState()
  return actions
}
